// Full i18n content for C & Partners CPA Limited (天行健會計師事務所)
// Languages: en (ENG), zh (繁體), cn (简体)

const BRAND_EN = { logoMain: "C & Partners", logoSub: "CPA Limited", accountants: "Certified Public Accountants", legal: "C & Partners CPA Limited" };
const BRAND_ZH = { logoMain: "C & Partners", logoSub: "CPA Limited", accountants: "執業會計師", legal: "C & Partners CPA Limited" };
const BRAND_CN = { logoMain: "C & Partners", logoSub: "CPA Limited", accountants: "执业会计师", legal: "C & Partners CPA Limited" };

export const translations = {
  /* ============================= ENGLISH ============================= */
  en: {
    brand: BRAND_EN,
    nav: { about: "About Us", team: "Our Team", services: "Our Services", join: "Join Us", contact: "Contact Us" },
    ui: { findOut: "Find Out More", knowMore: "View All Services", getInTouch: "Get In Touch", viewProfile: "View Profile", send: "Send", submitApp: "Send Résumé", home: "Home" },
    footer: { terms: "Terms of Use", privacy: "Privacy", disclaimer: "Disclaimer" },
    motto: "Integrity • Excellence • Innovation • Partnership",
    home: {
      heroTitle: "Professional Accounting & Advisory",
      heroBullets: ["Audit & Assurance", "Tax Advisory", "Corporate & Accounting Solutions"],
      servicesTitle: "Our Services",
      ctaTitle: "Contact Us",
      ctaText: "We are happy to hear from you.",
    },
    about: {
      pageTitle: "About Us",
      valuesTagline: "Integrity • Excellence • Innovation • Partnership",
      heading: "About C & Partners CPA Limited",
      intro: [
        "C & Partners CPA Limited is a professional accounting and advisory firm founded by experienced Certified Public Accountants (Practising) and technology professionals. Our partners collectively possess over 30 years of experience in audit, assurance, taxation, corporate advisory, risk management and business consulting.",
        "We provide professional, practical and value-driven solutions to businesses at every stage of development, from start-ups and SMEs to established corporations. We believe that professional services go beyond compliance. By combining deep industry expertise with innovative technology solutions, we help clients manage risks, seize opportunities and achieve sustainable growth.",
        "Guided by our core values of Integrity, Excellence, Innovation and Partnership, we are committed to building long-term trusted relationships and creating lasting value for our clients.",
      ],
      missionTitle: "Our Mission",
      mission: "To provide high-quality professional services with integrity, excellence and innovation, helping businesses create long-term value and achieve sustainable success.",
      visionTitle: "Our Vision",
      vision: "To become a trusted and respected professional services firm, recognised for our expertise, reliability, and commitment to client success.",
      valuesTitle: "Our Core Values",
      values: [
        { title: "Integrity", text: "We uphold the highest ethical and professional standards." },
        { title: "Professional Excellence", text: "We are committed to delivering quality services that exceed expectations." },
        { title: "Client-Centric Approach", text: "We listen, understand and provide tailored solutions to meet our clients' unique needs." },
        { title: "Innovation", text: "We embrace technology and continuous improvement to create greater value." },
        { title: "Partnership", text: "We grow together with our clients, employees and business partners." },
      ],
    },
    servicesPage: { pageTitle: "Our Services", indexHeading: "Our professional services" },
    teamPage: {
      pageTitle: "Our Team",
      partnersLabel: "Partners",
      certLabel: "Qualifications",
      intro: [
        "Our leadership team comprises experienced Certified Public Accountants (Practising) and professionals with extensive expertise in accounting, audit, taxation, corporate advisory, risk management and information technology.",
        "Together, our partners bring over four decades of professional experience serving clients across various industries, including multinational corporations, SMEs and start-up enterprises.",
      ],
    },
    careers: {
      pageTitle: "Join Us",
      heading: "Grow With Us",
      intro: [
        "At C & Partners CPA Limited, we believe our people are our greatest asset.",
        "We are committed to building a professional, collaborative and growth-oriented environment where individuals can develop their careers and realise their full potential.",
        "Whether you are an experienced professional or a fresh graduate, we offer opportunities for learning, professional development and career advancement.",
        "If you are passionate, motivated and committed to excellence, we would love to hear from you.",
      ],
      whyTitle: "Why Join Us?",
      whyPoints: [
        "Professional and supportive working environment",
        "Structured training and career development",
        "Exposure to diversified clients and industries",
        "Opportunities to work with experienced professionals",
        "Competitive remuneration and benefits",
      ],
      resumeLabel: "Send your resume to:",
      email: "admin@cnp-cpa.com",
    },
    contact: {
      pageTitle: "Contact Us",
      enquiriesTitle: "General Enquiries",
      hoursTitle: "Business Hours",
      hours: ["Monday – Friday", "9:00 a.m. – 6:00 p.m."],
      email: "admin@cnp-cpa.com",
      emailLabel: "Email",
      leaveMessage: "Leave a Message",
      labels: { name: "Name", tel: "Tel", email: "Email", message: "Message" },
      toastTitle: "Message sent",
      toastDesc: "Thank you for reaching out. We will reply to you shortly.",
      offices: [
        { name: "Hong Kong Office", address: ["1802, 18/F, Valley Centre", "80-82 Morrison Hill Road", "Wan Chai, Hong Kong"] },
        { name: "Kowloon Office", address: ["Room 1101, 11/F", "9 Chong Yip Street", "Kwun Tong, Kowloon"] },
      ],
    },
    services: [
      { id: "acct", title: "Professional Accounting Services", short: "Bookkeeping, financial reporting, management accounts preparation, accounting system implementation and outsourced accounting services." },
      { id: "secretarial", title: "Corporate Secretarial & Solutions", short: "Company incorporation, statutory compliance, annual filings, corporate restructuring and ongoing secretarial support." },
      { id: "audit", title: "Audit & Assurance", short: "Statutory audits, special purpose audits, due diligence reviews and assurance engagements conducted in accordance with professional standards." },
      { id: "tax", title: "Tax Advisory", short: "Hong Kong and international tax planning, tax compliance, tax investigations and advisory services." },
      { id: "governance", title: "Corporate Governance", short: "Governance framework review, compliance advisory and board support services to strengthen accountability and transparency." },
      { id: "ipo", title: "Pre-IPO Advisory", short: "Professional support for businesses preparing for listing, including internal control enhancement, financial reporting and compliance readiness." },
      { id: "liquidation", title: "Liquidation Advisory", short: "Advisory services relating to corporate restructuring, liquidation procedures and stakeholder management." },
      { id: "risk", title: "Risk Management & Internal Control Review", short: "Independent assessment of business risks, internal control systems and governance processes to improve operational effectiveness." },
    ],
    team: [
      { id: 1, name: "Wayne Fung", title: "Managing Director", certs: "CPA (Practising)", bio: ["Wayne Fung is the Managing Director of C & Partners CPA Limited. He is a Certified Public Accountant with over 15 years of experience in audit and assurance services. His expertise covers trading companies, investment holding companies, and financial services entities. He specializes in financial reporting, internal control reviews, risk assessment, and corporate governance advisory services."] },
      { id: 2, name: "Raymond Yeung", title: "Director", certs: "LLM, FCPA (Canada), FCGA, CPA (U.S.), CPA (Practising)", bio: ["Dr. Raymond Yeung is a Director of C & Partners CPA Limited. He has over 20 years of auditing experience. He has extensive expertise in auditing NGOs, government-funded projects, educational institutions, and professional bodies, with a strong understanding of regulatory compliance and governance requirements in the public and non-profit sectors."] },
      { id: 3, name: "Edward Chu", title: "Director", certs: "FCCA, FCPA, MHKCS, CPA (Practising)", bio: ["Edward Chu is a Director of C & Partners CPA Limited and a Certified Public Accountant with over 40 years of professional experience. He has extensive expertise in audit, accounting, and advisory services, serving clients across the manufacturing, trading, and investment holding sectors. His wealth of experience enables him to provide practical solutions on financial management, compliance, and business operations."] },
      { id: 4, name: "Bella Man", title: "Audit Principal", certs: "General Mediator", bio: ["Bella Man is the Audit Principal of C & Partners CPA Limited. With over 25 years of experience in financial management and operations, she specializes in taxation, non-profit governance, Section 88 charitable structures, fundraising compliance, and financial reporting. She also advises organizations on governance, operational efficiency, and regulatory compliance."] },
      { id: 5, name: "Hattie Sun", title: "Audit Manager", certs: "CPA, ACA (E&W)", bio: ["Hattie Sun is an Audit Manager and she has over 14 years of audit and taxation experience serving multinational corporations, trading companies, and non-profit organizations. She specializes in technical accounting, audit quality control, taxation, and internal control reviews."] },
      { id: 6, name: "Kit Ngan", title: "Audit Manager", certs: "CPA", bio: ["Kit Ngan is an Audit Manager and CPA Australia member with over 20 years of audit experience. She has extensive expertise in statutory and special-purpose audits for commercial enterprises, companies limited by guarantee, and non-profit organizations. Her strengths include risk-based auditing, internal control evaluation, and regulatory compliance."] },
      { id: 7, name: "Maggie Liu", title: "Senior Advisor", certs: "CPA (PRC), FCCA, FCMA, CPHR", bio: ["Maggie Liu has over 25 years of senior management experience in finance, corporate strategy, governance, and internal controls. She has served as Chief Financial Officer of listed and multinational corporations across manufacturing, retail, and consumer sectors, bringing extensive expertise in financial leadership and business transformation."] },
      { id: 8, name: "W. C. Yung", title: "IT Advisory", certs: "CISA, CISM", bio: ["W. C. Yung is a seasoned information technology professional with over 20 years of experience in information systems, computer auditing and information security advisory services. Having served international conglomerates and multinational organizations, he possesses extensive expertise in IT strategy, risk management, information systems analysis and technology governance. Mr. Yung specializes in helping organizations strengthen information security controls, manage technology risks and enhance operational efficiency through effective technology solutions."] },
    ],
  },

  /* ============================= 繁體中文 ============================= */
  zh: {
    brand: BRAND_ZH,
    nav: { about: "關於我們", team: "專業團隊", services: "專業服務", join: "加入我們", contact: "聯絡我們" },
    ui: { findOut: "了解更多", knowMore: "查看所有服務", getInTouch: "聯絡我們", viewProfile: "查看簡介", send: "發送", submitApp: "提交履歷", home: "主頁" },
    footer: { terms: "使用條款", privacy: "私隱政策", disclaimer: "免責聲明" },
    motto: "誠信 • 卓越 • 創新 • 共贏",
    home: {
      heroTitle: "專業會計及企業顧問",
      heroBullets: ["審計及鑑證", "稅務顧問", "企業及會計方案"],
      servicesTitle: "專業服務",
      ctaTitle: "聯絡我們",
      ctaText: "我們樂意聽取您的意見。",
    },
    about: {
      pageTitle: "關於我們",
      valuesTagline: "誠信 • 卓越 • 創新 • 共贏",
      heading: "關於 C & Partners CPA Limited",
      intro: [
        "天行健會計師事務所由多位資深執業會計師及資訊科技專才共同創立，致力提供專業會計、審計及企業顧問服務。合夥人團隊累積超過三十年專業經驗，專長涵蓋審計與鑑證、稅務顧問、企業管治、風險管理及商業顧問等領域。",
        "我們為不同發展階段的企業提供專業、務實及具價值的解決方案，服務對象涵蓋初創企業、中小企及成熟企業。我們深信專業服務的價值不僅在於符合法規要求，更在於為企業創造長遠價值。透過結合專業知識與創新科技，我們協助客戶管理風險、把握機遇，並實現可持續發展。",
        "秉持「誠信、卓越、創新、共贏」的核心理念，我們致力與客戶建立長遠互信的合作夥伴關係，攜手成長，共創價值。",
      ],
      missionTitle: "我們的使命",
      mission: "以誠信、專業及創新精神，為客戶提供高質素的專業服務，協助企業創造長遠價值。",
      visionTitle: "我們的願景",
      vision: "成為客戶最信賴的專業顧問夥伴，建立具影響力及備受尊重的專業服務品牌。",
      valuesTitle: "核心價值",
      values: [
        { title: "誠信為本", text: "堅守專業操守及道德標準。" },
        { title: "專業卓越", text: "追求高質素服務，超越客戶期望。" },
        { title: "客戶為先", text: "深入了解客戶需要，提供度身訂造方案。" },
        { title: "創新求進", text: "善用科技及持續學習，創造更大價值。" },
        { title: "攜手共贏", text: "與客戶、員工及合作夥伴共同成長。" },
      ],
    },
    servicesPage: { pageTitle: "專業服務", indexHeading: "我們的專業服務" },
    teamPage: {
      pageTitle: "專業團隊",
      partnersLabel: "合夥人",
      certLabel: "專業資格",
      intro: [
        "天行健會計師事務所匯聚多位資深執業會計師及資訊科技專才，結合專業會計知識與創新科技思維，為客戶提供全方位的專業服務。我們的專業團隊在審計與鑑證、稅務規劃、企業融資、企業管治、風險管理及商業顧問等領域擁有深厚經驗，能夠為不同發展階段的企業提供切實可行的策略建議及解決方案。",
        "各合夥人累積超過四十年專業經驗，服務對象涵蓋跨國企業、家族企業、中小企及初創企業。我們深信，每一家企業均有其獨特的發展路徑，因此我們秉持「誠信、專業、創新、共贏」的理念，深入了解客戶需要，以專業判斷及豐富經驗協助客戶把握機遇、管理風險，實現可持續發展及長遠價值。",
      ],
    },
    careers: {
      pageTitle: "加入我們",
      heading: "與我們一起成長",
      intro: [
        "人才是我們最重要的資產。",
        "我們致力建立專業、開放及積極進取的工作環境，為員工提供持續學習、專業培訓及晉升機會。",
        "無論您是應屆畢業生，還是擁有豐富經驗的專業人士，我們均歡迎有熱誠、有責任感及追求卓越的人才加入。",
      ],
      whyTitle: "為何選擇天行健？",
      whyPoints: [
        "專業及友善的工作環境",
        "完善培訓及晉升制度",
        "接觸多元化客戶及行業",
        "與資深專業人士共同成長",
        "具競爭力的薪酬及福利",
      ],
      resumeLabel: "歡迎提交履歷至：",
      email: "admin@cnp-cpa.com",
    },
    contact: {
      pageTitle: "聯絡我們",
      enquiriesTitle: "一般查詢",
      hoursTitle: "辦公時間",
      hours: ["星期一至星期五", "上午9時 – 下午6時"],
      email: "admin@cnp-cpa.com",
      emailLabel: "電郵",
      leaveMessage: "留言",
      labels: { name: "姓名", tel: "電話", email: "電郵", message: "訊息" },
      toastTitle: "訊息已發送",
      toastDesc: "感謝您的查詢，我們將盡快回覆您。",
      offices: [
        { name: "香港辦事處", address: ["香港灣仔", "摩理臣山道80-82號", "幸運中心18樓1802室"] },
        { name: "九龍辦事處", address: ["九龍觀塘", "昌業街9號", "11樓1101室"] },
      ],
    },
    services: [
      { id: "acct", title: "專業會計服務", short: "提供簿記、財務報表編製、管理帳目、會計系統設立及外判會計服務。" },
      { id: "secretarial", title: "公司秘書及企業方案", short: "提供公司註冊成立、法定申報、公司秘書服務、企業重組及合規支援。" },
      { id: "audit", title: "審計及鑑證服務", short: "根據專業準則提供法定審計、特別審計、盡職審查及鑑證服務。" },
      { id: "tax", title: "稅務顧問及稅務籌劃", short: "提供香港及國際稅務籌劃、報稅支援、稅務調查及專業顧問服務。" },
      { id: "governance", title: "企業管治", short: "協助企業建立良好管治架構，提升合規管理及企業透明度。" },
      { id: "ipo", title: "上市籌劃及上市前顧問服務", short: "為有意上市企業提供上市前規劃、財務準備、內部監控及合規顧問服務。" },
      { id: "liquidation", title: "企業清盤及重組顧問", short: "提供企業重組、清盤安排及相關專業顧問服務。" },
      { id: "risk", title: "企業風險管理及內部控制檢討", short: "檢討企業風險管理及內部監控系統，提升營運效率及企業管治水平。" },
    ],
    team: [
      { id: 1, name: "馮智立", title: "董事總經理", certs: "CPA (Practising)", bio: ["馮智立為天行健會計師事務所董事總經理，擁有超過十五年審計及鑑證服務經驗。其專業範疇涵蓋貿易企業、投資控股公司及金融服務機構，於財務報告、內部監控檢討、風險評估及企業管治顧問服務方面具備豐富經驗。他憑藉專業判斷及務實作風，致力為客戶提供高質素及具價值的專業服務。"] },
      { id: 2, name: "楊志良博士", title: "董事", certs: "LLM, FCPA (Canada), FCGA, CPA (U.S.), CPA (Practising)", bio: ["楊志良博士為天行健會計師事務所董事，擁有超過二十年審計專業經驗。其專長涵蓋非政府機構（NGOs）、政府資助項目、教育機構及專業團體之審計工作，對相關監管要求、合規標準及企業管治框架具有深入認識。他在公共及非牟利機構範疇擁有豐富實務經驗，能為客戶提供全面而專業的建議。"] },
      { id: 3, name: "朱廣樂", title: "董事", certs: "FCCA, FCPA, MHKCS, CPA (Practising)", bio: ["朱廣樂為天行健會計師事務所董事及執業會計師，擁有超過四十年專業經驗。多年來服務製造業、貿易業及投資控股企業等不同領域客戶，於審計、會計及企業顧問服務方面累積深厚經驗。憑藉豐富的專業知識及實務經驗，他能為企業提供切實可行的財務管理、合規及業務營運建議。"] },
      { id: 4, name: "文潔梅", title: "審計總監", certs: "General Mediator", bio: ["文潔梅為天行健會計師事務所審計總監，擁有超過二十五年財務管理及企業營運經驗。其專業範疇包括稅務規劃、非牟利機構管治、香港《稅務條例》第88條慈善架構設立、籌款活動合規管理及財務報告。她亦在企業管治、營運效率提升及監管合規方面擁有豐富經驗，致力協助機構建立穩健及可持續的管理架構。"] },
      { id: 5, name: "孫小雨", title: "審計經理", certs: "CPA, ACA (E&W)", bio: ["孫小雨為審計經理，擁有超過十四年審計及稅務經驗，曾服務跨國企業、貿易公司及非牟利機構等不同類型客戶。其專業領域包括技術會計、審計質量監控、稅務顧問及內部監控檢討。憑藉扎實的專業知識及豐富的項目經驗，她致力為客戶提供高質素及具前瞻性的專業服務。"] },
      { id: 6, name: "顏潔瑩", title: "審計經理", certs: "CPA", bio: ["顏潔瑩為審計經理及 CPA Australia 會員，擁有超過二十年審計經驗。她曾參與多類型法定審計及特別審計項目，包括商業企業、擔保有限公司及非牟利機構。顏女士於風險導向審計、內部監控評估及監管合規方面具備豐富經驗，能為客戶提供專業及務實的審計服務。"] },
      { id: 7, name: "柳敏", title: "高級顧問", certs: "CPA (PRC), FCCA, FCMA, CPHR", bio: ["柳敏擁有超過二十五年財務管理及企業策略經驗，曾於上市公司及跨國企業擔任首席財務官等高級管理職務，服務範疇涵蓋製造業、零售業及消費品行業。她在企業管治、財務規劃、內部監控、企業策略及業務轉型方面擁有豐富經驗，能為企業提供具策略性及前瞻性的專業建議。"] },
      { id: 8, name: "翁偉聰", title: "資訊科技顧問", certs: "CISA, CISM", bio: ["翁偉聰為資深資訊科技專業顧問，擁有超過二十年資訊系統、電腦審計及資訊保安顧問服務經驗。曾服務多家國際企業，於資訊科技策略、風險管理、資訊系統分析及科技管治等領域具備豐富經驗。他專注協助企業提升資訊保安管理、強化科技風險控制及優化營運效率，為客戶提供切實可行的科技解決方案。"] },
    ],
  },

  /* ============================= 简体中文 ============================= */
  cn: {
    brand: BRAND_CN,
    nav: { about: "关于我们", team: "专业团队", services: "专业服务", join: "加入我们", contact: "联系我们" },
    ui: { findOut: "了解更多", knowMore: "查看所有服务", getInTouch: "联系我们", viewProfile: "查看简介", send: "发送", submitApp: "提交履历", home: "主页" },
    footer: { terms: "使用条款", privacy: "隐私政策", disclaimer: "免责声明" },
    motto: "诚信 • 卓越 • 创新 • 共赢",
    home: {
      heroTitle: "专业会计及企业顾问",
      heroBullets: ["审计及鉴证", "税务顾问", "企业及会计方案"],
      servicesTitle: "专业服务",
      ctaTitle: "联系我们",
      ctaText: "我们乐意听取您的意见。",
    },
    about: {
      pageTitle: "关于我们",
      valuesTagline: "诚信 • 卓越 • 创新 • 共赢",
      heading: "关于 C & Partners CPA Limited",
      intro: [
        "天行健会计师事务所由多位资深执业会计师及资讯科技专才共同创立，致力提供专业会计、审计及企业顾问服务。合伙人团队累积超过三十年专业经验，专长涵盖审计与鉴证、税务顾问、企业管治、风险管理及商业顾问等领域。",
        "我们为不同发展阶段的企业提供专业、务实及具价值的解决方案，服务对象涵盖初创企业、中小企及成熟企业。我们深信专业服务的价值不仅在于符合法规要求，更在于为企业创造长远价值。透过结合专业知识与创新科技，我们协助客户管理风险、把握机遇，并实现可持续发展。",
        "秉持「诚信、卓越、创新、共赢」的核心理念，我们致力与客户建立长远互信的合作伙伴关系，携手成长，共创价值。",
      ],
      missionTitle: "我们的使命",
      mission: "以诚信、专业及创新精神，为客户提供高质素的专业服务，协助企业创造长远价值。",
      visionTitle: "我们的愿景",
      vision: "成为客户最信赖的专业顾问伙伴，建立具影响力及备受尊重的专业服务品牌。",
      valuesTitle: "核心价值",
      values: [
        { title: "诚信为本", text: "坚守专业操守及道德标准。" },
        { title: "专业卓越", text: "追求高质素服务，超越客户期望。" },
        { title: "客户为先", text: "深入了解客户需要，提供度身订造方案。" },
        { title: "创新求进", text: "善用科技及持续学习，创造更大价值。" },
        { title: "携手共赢", text: "与客户、员工及合作伙伴共同成长。" },
      ],
    },
    servicesPage: { pageTitle: "专业服务", indexHeading: "我们的专业服务" },
    teamPage: {
      pageTitle: "专业团队",
      partnersLabel: "合伙人",
      certLabel: "专业资格",
      intro: [
        "天行健会计师事务所汇聚多位资深执业会计师及资讯科技专才，结合专业会计知识与创新科技思维，为客户提供全方位的专业服务。我们的专业团队在审计与鉴证、税务规划、企业融资、企业管治、风险管理及商业顾问等领域拥有深厚经验，能够为不同发展阶段的企业提供切实可行的策略建议及解决方案。",
        "各合伙人累积超过四十年专业经验，服务对象涵盖跨国企业、家族企业、中小企及初创企业。我们深信，每一家企业均有其独特的发展路径，因此我们秉持「诚信、专业、创新、共赢」的理念，深入了解客户需要，以专业判断及丰富经验协助客户把握机遇、管理风险，实现可持续发展及长远价值。",
      ],
    },
    careers: {
      pageTitle: "加入我们",
      heading: "与我们一起成长",
      intro: [
        "人才是我们最重要的资产。",
        "我们致力建立专业、开放及积极进取的工作环境，为员工提供持续学习、专业培训及晋升机会。",
        "无论您是应届毕业生，还是拥有丰富经验的专业人士，我们均欢迎有热诚、有责任感及追求卓越的人才加入。",
      ],
      whyTitle: "为何选择天行健？",
      whyPoints: [
        "专业及友善的工作环境",
        "完善培训及晋升制度",
        "接触多元化客户及行业",
        "与资深专业人士共同成长",
        "具竞争力的薪酬及福利",
      ],
      resumeLabel: "欢迎提交履历至：",
      email: "admin@cnp-cpa.com",
    },
    contact: {
      pageTitle: "联系我们",
      enquiriesTitle: "一般查询",
      hoursTitle: "办公时间",
      hours: ["星期一至星期五", "上午9时 – 下午6时"],
      email: "admin@cnp-cpa.com",
      emailLabel: "电邮",
      leaveMessage: "留言",
      labels: { name: "姓名", tel: "电话", email: "电邮", message: "信息" },
      toastTitle: "信息已发送",
      toastDesc: "感谢您的查询，我们将尽快回覆您。",
      offices: [
        { name: "香港办事处", address: ["香港湾仔", "摩理臣山道80-82号", "幸运中心18楼1802室"] },
        { name: "九龙办事处", address: ["九龙观塘", "昌业街9号", "11楼1101室"] },
      ],
    },
    services: [
      { id: "acct", title: "专业会计服务", short: "提供簿记、财务报表编制、管理账目、会计系统设立及外判会计服务。" },
      { id: "secretarial", title: "公司秘书及企业方案", short: "提供公司注册成立、法定申报、公司秘书服务、企业重组及合规支援。" },
      { id: "audit", title: "审计及鉴证服务", short: "根据专业准则提供法定审计、特别审计、尽职审查及鉴证服务。" },
      { id: "tax", title: "税务顾问及税务筹划", short: "提供香港及国际税务筹划、报税支援、税务调查及专业顾问服务。" },
      { id: "governance", title: "企业管治", short: "协助企业建立良好管治架构，提升合规管理及企业透明度。" },
      { id: "ipo", title: "上市筹划及上市前顾问服务", short: "为有意上市企业提供上市前规划、财务准备、内部监控及合规顾问服务。" },
      { id: "liquidation", title: "企业清盘及重组顾问", short: "提供企业重组、清盘安排及相关专业顾问服务。" },
      { id: "risk", title: "企业风险管理及内部控制检讨", short: "检讨企业风险管理及内部监控系统，提升营运效率及企业管治水平。" },
    ],
    team: [
      { id: 1, name: "冯智立", title: "董事总经理", certs: "CPA (Practising)", bio: ["冯智立为天行健会计师事务所董事总经理，拥有超过十五年审计及鉴证服务经验。其专业范畴涵盖贸易企业、投资控股公司及金融服务机构，于财务报告、内部监控检讨、风险评估及企业管治顾问服务方面具备丰富经验。他凭借专业判断及务实作风，致力为客户提供高质素及具价值的专业服务。"] },
      { id: 2, name: "杨志良博士", title: "董事", certs: "LLM, FCPA (Canada), FCGA, CPA (U.S.), CPA (Practising)", bio: ["杨志良博士为天行健会计师事务所董事，拥有超过二十年审计专业经验。其专长涵盖非政府机构（NGOs）、政府资助项目、教育机构及专业团体之审计工作，对相关监管要求、合规标准及企业管治框架具有深入认识。他在公共及非牟利机构范畴拥有丰富实务经验，能为客户提供全面而专业的建议。"] },
      { id: 3, name: "朱广乐", title: "董事", certs: "FCCA, FCPA, MHKCS, CPA (Practising)", bio: ["朱广乐为天行健会计师事务所董事及执业会计师，拥有超过四十年专业经验。多年来服务制造业、贸易业及投资控股企业等不同领域客户，于审计、会计及企业顾问服务方面累积深厚经验。凭借丰富的专业知识及实务经验，他能为企业提供切实可行的财务管理、合规及业务营运建议。"] },
      { id: 4, name: "文洁梅", title: "审计总监", certs: "General Mediator", bio: ["文洁梅为天行健会计师事务所审计总监，拥有超过二十五年财务管理及企业营运经验。其专业范畴包括税务规划、非牟利机构管治、香港《税务条例》第88条慈善架构设立、筹款活动合规管理及财务报告。她亦在企业管治、营运效率提升及监管合规方面拥有丰富经验，致力协助机构建立稳健及可持续的管理架构。"] },
      { id: 5, name: "孙小雨", title: "审计经理", certs: "CPA, ACA (E&W)", bio: ["孙小雨为审计经理，拥有超过十四年审计及税务经验，曾服务跨国企业、贸易公司及非牟利机构等不同类型客户。其专业领域包括技术会计、审计质量监控、税务顾问及内部监控检讨。凭借扎实的专业知识及丰富的项目经验，她致力为客户提供高质素及具前瞻性的专业服务。"] },
      { id: 6, name: "颜洁莹", title: "审计经理", certs: "CPA", bio: ["颜洁莹为审计经理及 CPA Australia 会员，拥有超过二十年审计经验。她曾参与多类型法定审计及特别审计项目，包括商业企业、担保有限公司及非牟利机构。颜女士于风险导向审计、内部监控评估及监管合规方面具备丰富经验，能为客户提供专业及务实的审计服务。"] },
      { id: 7, name: "柳敏", title: "高级顾问", certs: "CPA (PRC), FCCA, FCMA, CPHR", bio: ["柳敏拥有超过二十五年财务管理及企业策略经验，曾于上市公司及跨国企业担任首席财务官等高级管理职务，服务范畴涵盖制造业、零售业及消费品行业。她在企业管治、财务规划、内部监控、企业策略及业务转型方面拥有丰富经验，能为企业提供具策略性及前瞻性的专业建议。"] },
      { id: 8, name: "翁伟聪", title: "资讯科技顾问", certs: "CISA, CISM", bio: ["翁伟聪为资深资讯科技专业顾问，拥有超过二十年资讯系统、电脑审计及资讯保安顾问服务经验。曾服务多家国际企业，于资讯科技策略、风险管理、资讯系统分析及科技管治等领域具备丰富经验。他专注协助企业提升资讯保安管理、强化科技风险控制及优化营运效率，为客户提供切实可行的科技解决方案。"] },
    ],
  },
};

// Language-independent assets
export const serviceImages = {
  acct: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  secretarial: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  audit: "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  tax: "https://images.unsplash.com/photo-1554224154-26032fdc8d0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  governance: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ipo: "https://images.unsplash.com/photo-1651416452811-eca925a924f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  liquidation: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  risk: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const memberImages = {
  1: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  2: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  3: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  4: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  5: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  6: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  7: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  8: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
};

export const serviceIconNames = {
  acct: "Calculator",
  secretarial: "FileText",
  audit: "ShieldCheck",
  tax: "Landmark",
  governance: "Scale",
  ipo: "TrendingUp",
  liquidation: "RefreshCw",
  risk: "ShieldAlert",
};
